import { action, autorun, observable, useStrict } from 'mobx';

import data from '../../data';

import {
  layout,
} from '../../theme';

useStrict();

const AppState = {
  activeNavItemIndex: 0,
  data: data,
  mouseX: null,
  mouseY: null,
  rem: parseInt(getComputedStyle(document.body)['font-size'], 10),
  scrollTop: document.body.scrollTop || document.documentElement.scrollTop || 0,
  touch: ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch, // eslint-disable-line
  bodyHeight: document.body.clientHeight,
  windowHeight: window.innerHeight,
  windowWidth: window.innerWidth,
  showScrollingListHelper: true,

  get navItems() {
    const items = [];
    items.push('Introduction');
    this.data.sections.topTen.lists.forEach(list => items.push(list.navHeading));
    return items;
  },

  get viewportX() {
    return this.mouseX !== null ? this.mouseX : null;
  },
  
  get viewportY() {
    return this.mouseY !== null ? this.mouseY - this.scrollTop : null;
  },
  
  get boxThumbnailArea() {
    const area = (this.windowHeight * this.windowWidth) * 0.025;
    const minArea = 20000;
    const maxArea = 100000;
    return area < minArea ? minArea : area > maxArea ? maxArea : area;
  },

  get boxSize() {
    return Math.sqrt(this.boxThumbnailArea) * 2;
  },

  get miniThumbnailArea() {
    return this.boxThumbnailArea * 0.04;   
  },
  
  get zoomedImageArea() {
    return this.boxThumbnailArea * 4;   
  },

  get compactMode() {
    return this.touch || this.windowWidth <= layout.MAX_WIDTH__COMPACT;
  },
  
  get regularMode() {
    return !this.touch && this.windowWidth >= layout.MIN_WIDTH__REGULAR;
  },

  set: action(function(prop, value) {
    this[prop] = value;
  }),
};

autorun(function() {
  if (AppState.touch) {
    document.documentElement.classList.remove('no-touch');
    document.documentElement.classList.add('touch');
  } else {
    document.documentElement.classList.remove('touch');
    document.documentElement.classList.add('no-touch');    
  }
});

export default observable(AppState);



// WEBPACK FOOTER //
// ./src/states/AppState/index.js